import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { LegacyDevice } from 'console/device/device';
import { Alert, Box, Button, ButtonGroup, ListItemIcon, Menu, MenuItem, Typography, } from '@mui/material';
import { ArrowDropDown, Build, Delete, VolumeMute, VolumeUp } from '@mui/icons-material';
import { Capability } from 'console/device/device-capability';
import { createSubsetSelector } from 'webui/utils/selectors';
import { fixHW205AMR, formatFilesystem, formatZTC700, } from 'console/redux/devices/items/actions';
import { selectDevice } from 'entities/device/lib';
var StaffButtonsAction;
(function (StaffButtonsAction) {
    StaffButtonsAction["format_sounds"] = "format_sounds";
    StaffButtonsAction["format_file_system"] = "format_file_system";
    StaffButtonsAction["fix_205_amr"] = "fix_205_amr";
})(StaffButtonsAction || (StaffButtonsAction = {}));
const staffButtonBlockSelector = createSubsetSelector([
    'device_type',
    'fix_hw205_amr_state',
    'hardware_type',
    'format_filesystem_state',
    'format_ztc700_state',
    'id',
    'capabilities',
    'filetransfers',
]);
export function StaffButtonsBlockTS(props) {
    const { device_id } = props;
    const device = usePartialAppSelector(selectDevice, device_id);
    const is_staff = useAppSelector((state) => state.account.is_staff);
    const r_device = staffButtonBlockSelector(device);
    const dispatch = useDispatch();
    const onFormatFilesystem = useCallback((device_id) => dispatch(formatFilesystem(device_id)), [dispatch]);
    const onFormatZTC700 = useCallback((device_id) => dispatch(formatZTC700(device_id)), [dispatch]);
    const onFixHW205AMR = useCallback((device_id) => dispatch(fixHW205AMR(device_id)), [dispatch]);
    function onClickFormatZTC700() {
        if (r_device != null) {
            onFormatZTC700(r_device.id);
        }
    }
    function onClickFormatFileSystem() {
        if (r_device != null) {
            onFormatFilesystem(r_device.id);
        }
    }
    function onClickFixHW205AMR() {
        if (r_device != null) {
            onFixHW205AMR(r_device.id);
        }
    }
    const code = r_device?.device_type?.code;
    const anchorRef = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    function onOpenMenu() {
        setAnchorEl(anchorRef.current);
    }
    function onCloseMenu() {
        setAnchorEl(null);
    }
    function onClickMenuItem(key) {
        return (event) => {
            event.preventDefault();
            switch (key) {
                case StaffButtonsAction.format_sounds:
                    return onClickFormatZTC700();
                case StaffButtonsAction.format_file_system:
                    return onClickFormatFileSystem();
                case StaffButtonsAction.fix_205_amr:
                    return onClickFixHW205AMR();
            }
        };
    }
    if (r_device == null)
        return null;
    const button_name = {
        request: 'отправка команды...',
        ok: 'команда отправлена',
        fail: 'ошибка',
        _other: 'Служебное',
    }[r_device.format_ztc700_state ??
        r_device.format_filesystem_state ??
        r_device.fix_hw205_amr_state ??
        '_other'];
    const menu_items = [
        LegacyDevice.has_capability(r_device?.capabilities, Capability.has_upload_voicepack_button) && (_jsxs(MenuItem, { onClick: onClickMenuItem(StaffButtonsAction.format_sounds), disabled: r_device.format_ztc700_state != null, children: [_jsx(ListItemIcon, { sx: {
                        minWidth: 30,
                    }, children: _jsx(VolumeUp, {}) }), {
                    request: 'отправка команды...',
                    ok: 'команда отправлена',
                    fail: 'ошибка',
                    _other: 'Отформатировать и перезагрузить звуки',
                }[r_device.format_ztc700_state ?? '_other']] }, StaffButtonsAction.format_sounds)),
        is_staff &&
            (code?.startsWith('ZTC-') ||
                code === 'H2000' ||
                LegacyDevice.has_capability(r_device?.capabilities, Capability.has_z3k_settings)) && (_jsxs(MenuItem, { onClick: onClickMenuItem(StaffButtonsAction.format_file_system), disabled: r_device.format_filesystem_state != null, children: [_jsx(ListItemIcon, { sx: {
                        minWidth: 30,
                    }, children: _jsx(Delete, {}) }), {
                    request: 'отправка команды...',
                    ok: 'команда отправлена',
                    fail: 'ошибка',
                    _other: 'Форматировать ФС',
                }[r_device.format_filesystem_state ?? '_other']] }, StaffButtonsAction.format_file_system)),
        ['204', '205', '207'].includes(r_device?.hardware_type?.code ?? 'unknown') && (_jsxs(MenuItem, { onClick: onClickMenuItem(StaffButtonsAction.fix_205_amr), disabled: LegacyDevice.filetransfer_in_progress(r_device.filetransfers, 'fix_hw205_amr'), children: [_jsx(ListItemIcon, { sx: {
                        minWidth: 30,
                    }, children: _jsx(VolumeMute, {}) }), _jsx(Typography, { variant: "inherit", noWrap: true, children: {
                        request: 'отправка команды...',
                        ok: 'команда отправлена',
                        fail: 'ошибка',
                        _other: 'исправить звуковые файлы',
                    }[r_device.fix_hw205_amr_state ?? '_other'] })] }, StaffButtonsAction.fix_205_amr)),
    ];
    const menu_count = menu_items.filter((item) => item).length;
    return (_jsxs(Box, { display: "flex", flexDirection: "row", flexWrap: "wrap", minWidth: 30, children: [LegacyDevice.has_capability(r_device?.capabilities, Capability.has_upload_voicepack_button) &&
                !LegacyDevice.has_capability(r_device?.capabilities, Capability.has_z3k_settings) && (_jsx(Box, { mr: 2, children: _jsx(Alert, { severity: "warning", children: "\u0424\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u043E\u0432\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043E\u0431\u044B\u0447\u043D\u043E \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F. \u041E\u043D\u043E \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u043D\u0430\u0434\u043E\u0431\u0438\u0442\u044C\u0441\u044F \u0432 \u0440\u0435\u0434\u043A\u0438\u0445 \u0441\u043B\u0443\u0447\u0430\u044F\u0445, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u043A\u043E\u0433\u0434\u0430 \u043F\u0440\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u043F\u0440\u043E\u0448\u0438\u0432\u043A\u0438 \u0431\u044B\u043B\u043E \u0432\u044B\u0434\u0430\u043D\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0431 \u043E\u0448\u0438\u0431\u043A\u0435." }) })), menu_count > 0 && (_jsxs(ButtonGroup, { variant: "outlined", color: "inherit", onClick: onOpenMenu, disabled: LegacyDevice.filetransfer_in_progress(r_device.filetransfers, 'fix_hw205_amr'), size: "small", children: [_jsx(Button, { startIcon: _jsx(Build, {}), children: button_name }), _jsx(Button, { size: "small", ref: anchorRef, sx: { padding: '2.325px 6px', minWidth: 30 }, children: _jsx(ArrowDropDown, {}) })] })), _jsxs(Menu, { open: !!anchorEl, anchorEl: anchorEl, onClose: onCloseMenu, keepMounted: true, transformOrigin: { vertical: 'top', horizontal: 'left' }, PaperProps: {
                    style: {
                        maxHeight: 48 * 4.5,
                    },
                }, children: [...menu_items] })] }));
}
